<template>
    <section>
        <div class="page" v-if="orderList && orderList.length">
            <a class="order" v-for="(item,index) in orderList" :key="index">
                <div class="order-fr">
                    <h3>
						<img src="./img/icon1.png" v-if='enums(item.status)=="Processing"'/>
						<img src="./img/icon1.png" v-if='enums(item.status)=="Issue Failed"'/>
						<img src="./img/icon3.png" v-if='enums(item.status)=="Failed" || enums(item.status)=="Closed"'/>
						<img src="./img/icon3.png" v-if='enums(item.status)=="Cancelled"'/>
						<img src="./img/icon4.png" v-if='enums(item.status)=="Current" || enums(item.status)=="Settled"'/>
						<img src="./img/icon6.png" v-if='enums(item.status)=="Overdue"'/>
						<img src="./img/icon4.png" v-if='enums(item.status)=="Extension"'/>
						<!-- <img src="./img/icon3.png" v-if='enums(item.status)=="Đã Thanh Toán"'/> -->
						<span>{{enums(item.status)}}</span>
					</h3>
                    <p>Loan Id：<span class="loan-id">{{item.orderId}}</span></p>
                    <p>Apply Time：<span>{{UTILS.dateFormatMatch(item.createTime)}}</span></p>
					<p v-if='enums(item.status)=="Overdue" || enums(item.status)=="Current" || enums(item.status)=="Settled"'>
						<template v-if="item.productType == 'DFEP'">
							Payment Due Date：<span>{{UTILS.dateFormatMatch(item.dueDate)}}</span>
						</template>
						<template v-else>
							<span v-if="item.productSeries == 'FUN1'">Due Date：</span>
							<span v-else>First Payment Due Date：</span>
							<span>{{UTILS.dateFormatMatch(item.dueDate)}}</span>
						</template>
					</p>
                </div>
				<div class="check" :class="item.status==65 ? 'Processing' : enums(item.status)" @click="check(item)">Check</div>
            </a>
        </div>
        <section v-else class="none">
            <img src="./img/none.png" />
        </section>
    </section>
</template>

<script>
export default{
    data(){
        return {
			orderList:[]
        }
    },
    metaInfo: {
        title: 'Order'
    },
    mounted: function() {
        var self = this;
		this.getOrderList()
    },
    methods:{
		getOrderList() {
			let self = this;
			self.UTILS.axiosRequest('post', self.PATHS.loanPath + '/order/list', {}, function(res) {
				self.UTILS.loadGif.hide();
				if (res.code == '0000') {
					self.orderList = res.data;
				} else {
					self.UTILS.logStr(res.message);
				}
			}, 1);
		},
		
		check(item){
			location.href = `./orderDetails.html?orderId=${item.orderId}`
		},
		
		enums(val){
			if(val < 65){
				return "Processing"
			}else if(val == 65){
				return "Issue Failed"
			}else if(val == 70){
				return "Current"
			}else if(val == 80){
				return "Overdue"
			}else if(val == 90){
				return "Extension"
			}else if(val == 95 || val == 100){
				return "Settled"
			}else if(val == 110 || val == 120){
				return "Failed"
			}else if(val == 130){
				return "Cancelled"
			}else if(val == 140){
				return "Closed"
			}
		}
    }
}
</script>

<style scoped>
.page{ padding-top: 0.3rem;}
.order{ width: 7.0rem; background-color: #FFF; border-radius: 0.18rem; display: flex;align-items: center; margin: 0 auto 0.2rem auto;padding: 0.2rem;}
.order img{ width: 0.6rem; height: 0.6rem;margin-right: 0.2rem;}
.check{padding:0.1rem 0.22rem;border-radius: 0.3rem;background-color: #ABADB3;color: #fff;font-size: 14px;text-align: center;box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.24);}

.Processing{background-color: #ED7D31;}
.Overdue{background-color: #FA6142;}
.Current{background-color: #ED7D31;}
.Settled{background-color: #7DC31B;}
.Extension{background-color: #7DC31B;}

.order-fr{flex:1;}
.order-fr h3{display: flex;align-items: center;margin-bottom: 0.1rem;}
.order h3 span{font-size: 0.3rem; font-weight: normal; color: #040507;}
.order-fr p{display: flex;align-items: center;line-height: 0.48rem; font-size: 0.24rem; color: #6F6F6F;}
.order-fr .loan-id{width: 3.0rem;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: inline-block;}
.order-fr span{ font-size: 0.24rem; color: #333;}
.order-fr i{ line-height: 0.6rem; font-size: 0.26rem; font-style: normal; text-align: right; color: #040507; display: block; margin-top: 0.26rem;}
.none{ width: 100%;max-width:750px; height: 100%; padding-top: 1.8rem; background-color: #FFF; position: fixed;}
.none img{ width: 4.3rem; display: block; margin: 0 auto;}
</style>
